import { ALERT_TYPE } from "components/common/Alert";
import { useStyles } from "components/request-document/components/Commons";
import UploadDucument from "components/request-document/components/UploadDucument";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import { M24_CONFIG_DOC } from "libs/configs/constant";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import useAlert from "libs/hooks/useAlert";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectM24SwitchMode } from "redux/modules/m24SwitchModeSlice";
import {
  getSmartCompany,
  selectUploadSmartCompanyDoc,
  uploadSmartCompanyDocSlice,
} from "redux/modules/smartCompanySlice";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import {
  documentRequiredSlice,
  getDocumentRequired,
} from "redux/modules/visaForm";

export default function CompanyDocument({ onClickBack }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { personalId } = usePersonalDetail();
  const { draftId, getSmartForm } = useSmartForm();
  const { showLoading, hideLoading } = useModalLoading();
  const { showAlert, hideAlert } = useAlert();

  const userProfile = useSelector((state) => state.user.profile);
  const uploadSmartCompanyDocState = useSelector(selectUploadSmartCompanyDoc);
  const m24SwitchMode = useSelector(selectM24SwitchMode);

  const smartCompanyID = get(userProfile, "smartCompanyID", null);
  const smartserviceId =
    M24_CONFIG_DOC[m24SwitchMode]?.SMART_SERVICE_ID ?? null;
  const ConditionType = M24_CONFIG_DOC[m24SwitchMode]?.CONDITION_TYPE ?? null;

  useEffect(() => {
    dispatch(getDocumentRequired({ smartserviceId, ConditionType }));
    dispatch(getSmartCompany(smartCompanyID));
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (uploadSmartCompanyDocState.isLoading) {
      showLoading();
    } else if (!uploadSmartCompanyDocState.isLoading) {
      if (uploadSmartCompanyDocState.isSuccess) {
        hideLoading();
        dispatch(uploadSmartCompanyDocSlice.actions.clearAsyncState());

        dispatch(documentRequiredSlice.actions.clearAsyncState());
        dispatch(getDocumentRequired({ smartserviceId, ConditionType }));
        dispatch(getSmartCompany(smartCompanyID));

        showAlert({
          type: ALERT_TYPE.SUCCESS,
          title: "Update complete",
          description: "You have been uploaded document successfully",
          button: [
            {
              title: "Done",
              onClick: () => {
                hideAlert();
                dispatch(setHomeTab(HOME_TAB.EMPLOYEE_LIST));
              },
            },
          ],
        });
      } else if (uploadSmartCompanyDocState.isFailure) {
        hideLoading();
        alert(uploadSmartCompanyDocState.error?.message);
        dispatch(uploadSmartCompanyDocSlice.actions.clearAsyncState());
      }
    }
  }, [uploadSmartCompanyDocState, dispatch, hideLoading, showLoading]);

  return (
    <div>
      <UploadDucument
        isBypassAccept
        hideDetailHeader
        hideSummary
        nextButtonText="Save"
        customTextRemark="* All documents must be affixed with a company seal and signed by the authorized person(s)"
        isCompanyUploadDoc
        onClickBack={onClickBack}
        onClickNextAdmin={() => {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
        }}
      />
    </div>
  );
}
